import React, { useState, useCallback } from 'react';
import { Modal, Input, Mark } from '@roo/roo';
import request from '@/utils/request';
import utils from '@/utils/utils';
import { Review } from '../types';
import reducer from './reducer';
import './index.scss';

interface ReplyModalProps {
    isVisible: boolean;
    review: Review | null;
    /** 关闭回复弹窗时的回调函数 */
    onCancel?: () => void;
    /** 回复成功时的回调函数，注意此方法会自动调用 `onCancel`（即关闭回复弹窗） */
    onSuccess?: () => void;
}

const ReplyModal: React.FC<ReplyModalProps> = ({ isVisible, review, onSuccess, onCancel }) => {
    const [replyContent, setReplyContent] = useState('');

    const handleReplyContentChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setReplyContent(e.target.value);
    }, []);

    const handleCancel = useCallback(() => {
        onCancel?.();
        setReplyContent('');
    }, [onCancel]);

    const handleReply = () => {
        request
            .post('/api/evaluate/reply', {
                // `handleReply` 调用时弹窗应当为打开状态，即 `isVisible` 为 `true`
                // 相应地，`review` 应当不为 `null`
                commentId: review!.commentId,
                replyDetail: replyContent.trim(),
            })
            .then(res => {
                if (res.code === 0) {
                    onSuccess?.();
                    handleCancel();
                } else {
                    throw new Error(res.msg);
                }
            })
            .catch((error: Error) => {
                utils.toast('error', error.message);
            });
    };

    return (
        <Modal
            className="reply-modal"
            visible={isVisible}
            onCancel={handleCancel}
            onConfirm={handleReply}
            title="回复评价"
            confirmButtonProps={{
                disabled: !replyContent.trim(),
            }}
        >
            {review && (
                <>
                    <div className="reply-modal__review-info">
                        <div className="reply-modal__review-buyer">{review.acctLogin}</div>
                        <div className="reply-modal__review-score">
                            <Mark defaultValue={review.score} disabled />
                        </div>
                        <div className="reply-modal__review-detail">
                            {review.commentDetail || '用户未填写评价'}
                        </div>
                    </div>
                </>
            )}
            <Input.Textarea
                style={{ height: 130 }}
                value={replyContent}
                onChange={handleReplyContentChange}
                resize="none"
                placeholder="最多可以回复300字，请勿恶意回复，一经核实将严肃处理"
                maxLength={300}
            />
        </Modal>
    );
};

export default ReplyModal;

export { reducer as replyModalReducer };
